import http from '../../lib/http'

export const EXTERNAL_RECEIVERS_SUCCESS = 'EXTERNAL_RECEIVERS_SUCCESS'
export const EXTERNAL_RECEIVERS_FAILURE = 'EXTERNAL_RECEIVERS_FAILURE'
export const ORGANIZATIONS_SUCCESS = 'ORGANIZATIONS_SUCCESS'
export const ORGANIZATIONS_FAILURE = 'ORGANIZATIONS_FAILURE'
export const CONFIG_SUCCESS = 'CONFIG_SUCCESS'
export const CONFIG_FAILURE = 'CONFIG_FAILURE'

export function getExternalRecivers () {
  return dispatch =>
    http
      .getRequest('/admin/receivers')
      .then(data =>
        dispatch({
          type: EXTERNAL_RECEIVERS_SUCCESS,
          results: data
        }))
      .catch(err =>
        dispatch({
          type: EXTERNAL_RECEIVERS_FAILURE,
          err
        }))
}

export function getOrganizations () {
  return dispatch =>
    http
      .getRequest('/admin/organizations')
      .then(data =>
        dispatch({
          type: ORGANIZATIONS_SUCCESS,
          results: data
        }))
      .catch(err =>
        dispatch({
          type: ORGANIZATIONS_FAILURE,
          err
        }))
}

export function getConfig () {
  return dispatch =>
    http
      .getRequest('/admin/config')
      .then(data =>
        dispatch({
          type: CONFIG_SUCCESS,
          results: data
        }))
      .catch(err =>
        dispatch({
          type: CONFIG_FAILURE,
          err
        }))
}
